import { InternalAxiosRequestConfig } from "axios";
import { fingerprint } from "@/utils/fingerprint";

export default async function deviceId(config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> {
  const id = await fingerprint();

  config.headers["X-Device-ID"] = id;

  return config;
}
